<template>
  <div>
    <base-title
      title="Google Analytics"
      :subtitle="StringLanguage.integrations"
      link="integracoes"
    />

    <div class="integration-details">
      <div class="header no_underline">
        <div class="wrapper">
          <p class="title">Sobre o Google Analytics</p>
          <img
            src="@/assets/img/integration.svg"
            class="img-fluid mobile"
            alt="Integrações"
          />
          <p class="description">
            Google Analytics é a ferramenta de monitoramento e análise de sites
            mais utilizada no mundo. Ela se integra com outros serviços do
            Google, como Ads e Search Console. Com ela é possível monitorar o
            perfil de quem acessa seu site, páginas mais acessadas, conversões,
            dispositivos, cidades e outros dados.
          </p>
        </div>
        <img
          src="@/assets/img/integration.svg"
          class="img-fluid desktop"
          alt="Integrações"
        />
      </div>

      <!--       <div class="register">
        <base-button
          text="Cadastrar"
          class="big w-100"
          @click="changeRoute('cadastro-google-analytics')"
        />

        <div class="help">
          <p>Tem dúvidas? Acesse&nbsp;</p>
          <a
            href="https://ajuda.easydelivery.com.br/"
            target="_blank"
            class="link"
            >https://ajuda.easydelivery.com.br/</a
          >
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import '@/assets/css/veasy/integrations.css';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';

export default {
  components: {
    BaseTitle,
    BaseButton,
  },
  methods: {
    changeRoute(routeName) {
      this.$router.push({ name: routeName });
    },
  },
};
</script>
